import React from 'react';
import type { IconBaseProps, IconType } from 'react-icons';

type Props = IconBaseProps & {
  icon: IconType;
};

/**
 * react-icons v5 types declare IconType returns ReactNode, which CRA/TS4 may reject as a JSX component.
 * This wrapper renders icons via a function call, keeping JSX typing happy in production builds.
 */
export function Icon({ icon, ...props }: Props) {
  return <>{icon(props)}</>;
}


